import posthog from 'posthog-js'

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(import.meta.env.POSTHOG_DASHBOARD_KEY, {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
      //** Set POSTHOG_OPT_OUT env variable to true to opt out of capturing in development
      opt_out_capturing_by_default: !!import.meta.env.POSTHOG_OPT_OUT || false,
      opt_out_persistence_by_default: !!import.meta.env.POSTHOG_OPT_OUT || false,
    })
  },
}
